import { SET_NOTIFICATION, RESET_NOTIFICATION } from "./index";

export const setNotification = (code, message, description, duration = null) => ({
  type: SET_NOTIFICATION,
  code,
  message,
  description,
  duration,
});

export const resetNotification = () => ({
  type: RESET_NOTIFICATION,
});
